import React from 'react'
import './StatsSection.css'

const StatsSection = () => {
  return (
    <section className="VzoaWq DyMfb_">
      <div className="b_L6f_">
        <div className="o4syl7">
          <div className="q57VaS _5zZKyX _LNaGn aos-init aos-animate" data-aos="fade-up">
            <div className="lGVdcF">
              <div className="ga95vF">
                <h3 className="gsoLYE NYk8Bp">+$100 000 000</h3>
              </div>
              <p className="N4mo6s">Amount of the risky funds detected</p>
            </div>
          </div>
          <div className="q57VaS _5zZKyX _LNaGn aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="lGVdcF">
              <div className="ga95vF">
                <div className="_1mVFjs">
                  <div>
                    <img
                      alt="Binance"
                      loading="lazy"
                      width="140"
                      height="29"
                      decoding="async"
                      data-nimg="1"
                      style={{ color: 'transparent' }}
                      src="https://amlbot.com/_next/static/media/binance-white.aed1452d.svg"
                    />
                  </div>
                  <div>
                    <img
                      alt="OKX"
                      loading="lazy"
                      width="72"
                      height="29"
                      decoding="async"
                      data-nimg="1"
                      style={{ color: 'transparent' }}
                      src="https://amlbot.com/_next/static/media/okx-white.32ece2b9.svg"
                    />
                  </div>
                  <div>
                    <img
                      alt="Huobi"
                      loading="lazy"
                      width="88"
                      height="29"
                      decoding="async"
                      data-nimg="1"
                      style={{ color: 'transparent' }}
                      src="https://amlbot.com/_next/static/media/huobi-white.ef112ac0.svg"
                    />
                  </div>
                </div>
              </div>
              <p className="N4mo6s">Compliance departments that accept our AML procedures</p>
            </div>
          </div>
          <div className="q57VaS _5zZKyX _LNaGn aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
            <div className="lGVdcF">
              <div className="ga95vF">
                <h4 className="gsoLYE">60,000+</h4>
              </div>
              <p className="N4mo6s">Service providers checked</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StatsSection
